import { render, staticRenderFns } from "./InterventionAnomalies.vue?vue&type=template&id=7880e1d7"
import script from "./InterventionAnomalies.vue?vue&type=script&lang=ts"
export * from "./InterventionAnomalies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports